import { render, staticRenderFns } from "./VxCollapse.vue?vue&type=template&id=430d42be&"
import script from "./VxCollapse.vue?vue&type=script&lang=js&"
export * from "./VxCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports